export default __webpack_public_path__ + "static/media/Chhattisgarh.c6cb51e8.jpg";